export default __webpack_public_path__ + "static/media/map.4e0d614f.svg";